// tslint:disable-next-line:no-namespace
namespace HA {
    export class ServiceManager extends HA.HAObject {

        /**
         *
         * @param services
         */
        public addServices(services: Map<string, () => void>): void {
            services.forEach((func: () => void, name: string) => {
                this.addService(name, func);
            });
        }

        /**
         *
         * @param serviceName
         * @param func
         */
        public addService(serviceName: string, func: () => void) {
            this.__getService().set(serviceName, func);
        }

        /**
         *
         * @param names
         * @returns {Map<string, Function>}
         */
        public getServices(names: string[]) {
            const result: Map<string, () => void> = new Map();

            names.forEach((name) => {
                result.set(name, this.getService(name));
            });

            return result;
        }

        /**
         *
         * @param name
         * @returns {any}
         */
        public getService(name: string) {
            return this.__getService().get(name);
        }

        /**
         *
         * @param data
         */
        protected initialize(data?: Map<string, any>) {
            if (data) {
                super.initialize({__services: data});
            }
        }

        /**
         *
         * @returns {any}
         * @private
         */
        protected __getService() {
            return this.get("__services");
        }
    }
}
